import React, { lazy } from "react";
import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import SecureLS from "secure-ls";
import ProtectedRoutes from "./ProtectedRoutes";
import RouteSuspense from "./RouteSuspense";
import UnauthorizedAccess from "../pages/UnauthorizedAccess";
import RetailSidebarLayout from "../components/retail/RetailSidebarLayout";
import AdminSidebarLayout from "../components/adminDashboard/AdminSidebarLayout";
import StoreGuard from "./StoreGuard";
import PublicLiveRoutes from "./live/PublicLiveRoutes";
import AdminLiveRoutes from "./live/AdminLiveRoutes";
import BusinessLiveRoutes from "./live/BusinessLiveRoutes";
import RestaurantLiveRoutes from "./live/RestaurantLiveRoutes";
import RetailLiveRoutes from "./live/RetailLiveRoutes";

const KioskPage = lazy(() => import("../pages/kiosk/KioskPage"));
const KioskLandingPage = lazy(() =>
  import("../pages/kiosk/components/KioskLandingPage")
);

const ls = new SecureLS({ encodingType: "aes" });

const BusinessRouteLayout = () => {
  const user = ls.get("user");

  if (user?.accountType === "retail") {
    return (
      <RetailSidebarLayout>
        <Outlet />
      </RetailSidebarLayout>
    );
  }

  return <Outlet />;
};

const AdminRouteLayout = () => {
  const user = ls.get("user");

  if (!user?.inhouseAdmin && user?.role !== "Superadmin") {
    return <UnauthorizedAccess />;
  }

  return (
    <AdminSidebarLayout>
      <Outlet />
    </AdminSidebarLayout>
  );
};

const LiveRoutes = () => (
  <Routes>
    {PublicLiveRoutes()}

    <Route element={<ProtectedRoutes />}>
      <Route element={<AdminRouteLayout />}>{AdminLiveRoutes()}</Route>

      <Route element={<BusinessRouteLayout />}>
        {BusinessLiveRoutes()}
        {RestaurantLiveRoutes()}
        {RetailLiveRoutes()}
      </Route>

      <Route
        path="/:posId"
        element={
          <StoreGuard wantsOrder={false} isMobile={false}>
            <RouteSuspense>
              <KioskLandingPage />
            </RouteSuspense>
          </StoreGuard>
        }
      />
      <Route
        path="/:posId/order"
        element={
          <StoreGuard wantsOrder={true} isMobile={false}>
            <RouteSuspense>
              <KioskPage />
            </RouteSuspense>
          </StoreGuard>
        }
      />
    </Route>

    <Route path="*" element={<Navigate to="/404" replace />} />
  </Routes>
);

export default LiveRoutes;
